import script from "./WikiRoleGuide.vue?vue&type=script&setup=true&lang=ts"
export * from "./WikiRoleGuide.vue?vue&type=script&setup=true&lang=ts"

import "./WikiRoleGuide.vue?vue&type=style&index=0&id=1f76b18e&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f76b18e"]])

export default __exports__